import { ConfiguredDeliveryPolicy, DeliveryPolicy } from 'components/ordering/acl/internal-types.js'


export interface SetBasketDeliveryPolicyPayload {
  shop_id: number
  delivery_policy: object | number
  basket_id: string
}

export interface GetDeliveryPoliciesPayload {
  shop_id: number
  party_id: number
}

export class SetBasketDeliveryPolicyRequest {
  endpointUrl: URL
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }
  data: SetBasketDeliveryPolicyPayload

  constructor(endpoint: string, shopId: number, basket_id: string, deliveryPolicy: DeliveryPolicy) {
    this.endpointUrl = new URL(endpoint + 'SetBasketDeliveryPolicy/', window.location.href)
    this.data = {
      shop_id: shopId,
      delivery_policy: deliveryPolicy instanceof ConfiguredDeliveryPolicy ? deliveryPolicy.id : {},
      basket_id: basket_id
    }
  }
}
